import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../../context/auth/useAuth'
import { Link,useNavigate, useParams } from 'react-router-dom'
import Select from "react-select"
import { editMenu, deleteMenu, getMenu } from '../../../../actions/menusActions'
import Swal from 'sweetalert2'
import { getProducts } from '../../../../actions/productsActions'

export default function MenusEdit() {
  	const { t } = useTranslation()
	const dispatch = useDispatch()
    const navigate = useNavigate()
	const {client} = useAuth()

    const { id } = useParams()

	const {menu, resultmenu} = useSelector(state=>state.menus)
	const {products} = useSelector(state=>state.products)

    const [firstdishesTextIcons, setFirstdishesTextIcons] = useState([])
    const [seconddishesTextIcons, setSeconddishesTextIcons] = useState([])
    const [dessertsTextIcons, setDessertsTextIcons] = useState([])
    // const [drinksTextIcons, setDrinksTextIcons] = useState([])
    // const [complementsTextIcons, setComplementsTextIcons] = useState([])

    const [dataMenus, setDataMenus] = useState()
    const [isEditing, setIsEditing] = useState(false)

	useEffect(() => {
		if(client){
			dispatch(getMenu(id))
			dispatch(getProducts())
		}
	},[dispatch, t, client, id])

    useEffect(()=>{
        if (menu && products) {
            let firstdishesArray = []
            let firstdishesSelectedArray = []
            let seconddishesArray = []
            let seconddishesSelectedArray = []
            // let drinksArray = []
            // let drinksSelectedArray = []
            let dessertArray = []
            let dessertsSelectedArray = []
            // let complementsArray = []
            // let complementsSelectedArray = []

            products?.forEach(product => {
                let object
                if(product?.type === 'Dish'){
                    if(product?.photo){
                        object = {value: product?._id, label: <div><img src={product?.photo} alt={product?.name} height="30px" width="30px"/> {product?.name}</div>}
                    }else{
                        object = {value: product?._id, label: <div>{product?.name}</div>}
                    }
                    if (menu.firstdishes?.includes(product?._id)) {
                        firstdishesSelectedArray.push(object)
                    }
                    if (menu.seconddishes?.includes(product?._id)) {
                        seconddishesSelectedArray.push(object)
                    }
                    firstdishesArray.push(object)
                    seconddishesArray.push(object)
                    // if (menu.complements?.includes(product._id)) {
                    //     complementsSelectedArray.push(object)
                    // }
                    // if(product.isComplement){
                    //     complementsArray.push(object)
                    // }
                }
                // if(product.type === 'Drink'){
                //     if(product.photo){
                //         object = {value: product._id, label: <div><img src={product.photo} alt={product.name} height="30px" width="30px"/> {product.name}</div>}
                //     }else{
                //         object = {value: product._id, label: <div>{product.name}</div>}
                //     }
                //     if (menu.drinks?.includes(product._id)) {
                //         drinksSelectedArray.push(object)
                //     }
                //     drinksArray.push(object)
                //     if (menu.complements?.includes(product._id)) {
                //         complementsSelectedArray.push(object)
                //     }
                //     if(product.isComplement){
                //         complementsArray.push(object)
                //     }
                // }
                if(product?.type === 'Dessert'){
                    if(product?.photo){
                        object = {value: product?._id, label: <div><img src={product?.photo} alt={product?.name} height="30px" width="30px"/> {product?.name}</div>}
                    }else{
                        object = {value: product?._id, label: <div>{product?.name}</div>}
                    }
                    if (menu.desserts?.includes(product?._id)) {
                        dessertsSelectedArray.push(object)
                    }
                    dessertArray.push(object)
                    // if (menu.complements?.includes(product._id)) {
                    //     complementsSelectedArray.push(object)
                    // }
                    // if(product.isComplement){
                    //     complementsArray.push(object)
                    // }
                }
            })

            setFirstdishesTextIcons({options: firstdishesArray, selected: null})
            setSeconddishesTextIcons({options: seconddishesArray, selected: null})
            // setDrinksTextIcons({options: drinksArray, selected: null})
            setDessertsTextIcons({options: dessertArray, selected: null})
            // setComplementsTextIcons({options: complementsArray, selected: null})

            setDataMenus({
                ...menu,
                firstdishes: firstdishesSelectedArray,
                seconddishes: seconddishesSelectedArray,
                // drinks: drinksSelectedArray,
                desserts: dessertsSelectedArray,
                // complements: complementsSelectedArray
            })
        }
    }, [menu, products, client, dispatch])

    const handleInputChange = ({target})=>{
        setDataMenus({
            ...dataMenus,
            [target.name]: target.value
        })
    }

    const handleSelectChange = async(typeproduct, arrayProducts) => {
        setDataMenus({
            ...dataMenus,
            [typeproduct]: arrayProducts
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()
        setIsEditing(true)

        let arrayFirstdishes = dataMenus?.firstdishes?.map(firstdish => {
            return firstdish.value
        })
        let arraySeconddishes = dataMenus?.seconddishes?.map(seconddish => {
            return seconddish.value
        })
        let arrayDesserts = dataMenus?.desserts?.map(dessert => {
            return dessert.value
        })
        // let arrayDrinks = dataMenus?.drinks?.map(drink => {
        //     return drink.value
        // })
        // let arrayComplements = dataMenus?.complements?.map(complement => {
        //     return complement.value
        // })

        dispatch(editMenu({
            ...dataMenus,
            firstdishes: arrayFirstdishes,
            seconddishes: arraySeconddishes,
            desserts: arrayDesserts,
            // drinks: arrayDrinks,
            // complements: arrayComplements
        }, id))
        setIsEditing(false)

    }
    const handleDelete = () => {
        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.yes'),
            icon: 'warning',
            text: t('admin.menus.menudelete')
        }).then(() => {
            dispatch(deleteMenu(id))
        })
    }

    useEffect(() => {
        if(resultmenu){
            switch (resultmenu) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.menus.menuedit')
                    }).then(() => {                        
                        navigate('/admin/menus')
                    })
                    break;
                case 'Eliminado':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.menus.menudeleteok')
                    }).then(() => {
                        dispatch(deleteMenu(id))
                        navigate('/admin/menus')
                    })
                    break;
                case 'DeleteMenuError':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'error',
                        text: t('admin.menus.menudeleteerror')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultmenu])

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/menus">
                        <img src="/images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.menus.editmenu')}</h1>
                </Col>
                <Col xs={2}>
                    <Button variant='danger' className="w-100 my-2" onClick={handleDelete}>
                    {isEditing
                        ?
                            <>
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </>
                        :
                            <>{t('admin.menus.delete')}</>
                    }
                    </Button>
                </Col>
            </Row>
            <Row className="mt-5">
                <Form className="px-4 formulario" onSubmit={handleEdit}>
                    <Row className="text-center mt-3">
                        <h2 className="sd-label text-start">{t('admin.menus.namemenu')}</h2>
                    </Row>
                    <Row className="text-center mb-3 row-eye">
                        <Form.Control
                            className="sd-input"
                            type='text'
                            name='name' 
                            value={dataMenus?.name ||  ''}
                            placeholder={t('admin.menus.setname')}
                            onChange={handleInputChange}
                            required
                        />
                        <img className="sd-imageneye" src="/images/pencil.svg" alt="pencil" width={15}></img>
                    </Row>
                    <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.price')}</h2>
                        <Form.Control
                            className="sd-input"
                            type='text'
                            name='price'
                            value={dataMenus?.price ||  ''}
                            placeholder={t('admin.menus.price')}
                            onChange={handleInputChange}
                            required
                        />
                    </Row>
                    <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.firstdishesmenu')}</h2>
                        <Select
                            className="text-start p-0"
                            isMulti
                            name={'firstdishes'}
                            options={firstdishesTextIcons?.options}
                            value={dataMenus?.firstdishes}
                            onChange={(e) => handleSelectChange('firstdishes', e)}
                            // Usamos getOptionLabel solo para la búsqueda por texto
                            getOptionLabel={(option) => {
                                const labelChildren = option?.label?.props?.children;

                                // If labelChildren is an array, filter the strings
                                if (Array.isArray(labelChildren)) {
                                    const labelText = labelChildren.filter(child => typeof child === 'string');
                                    return labelText.join('');
                                }
                            
                                // If labelChildren is not an array (likely a string), return it directly
                                if (typeof labelChildren === 'string') {
                                    return labelChildren;
                                }
                            
                                // Fallback in case none of the above conditions are met
                                return option.label;
                            }}
                            // Usamos formatOptionLabel para renderizar la opción con imagen y texto
                            formatOptionLabel={(option) => {
                                const children = option?.label?.props?.children;
                            
                                // Verificamos si hay una imagen en la primera posición de los children
                                const image = children?.[0]?.props?.src 
                                    ? (
                                        <img
                                            src={children[0]?.props?.src}
                                            alt={children[0]?.props?.alt || 'Imagen del plato'}
                                            style={{ height: '30px', width: '30px', marginRight: '10px' }}
                                        />
                                    )
                                    : null;
                            
                                // Extraemos el texto de los children
                                const text = Array.isArray(children)
                                    ? children.filter(child => typeof child === 'string').join('') || children[2]
                                    : typeof children === 'string'
                                    ? children
                                    : '';
                            
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {image}
                                        <span>{text}</span>
                                    </div>
                                );
                            }}

                            required
                        />
                    </Row>
                    <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.seconddishesmenu')}</h2>
                        <Select
                            className="text-start p-0"
                            isMulti
                            name={'seconddishes'}
                            options={seconddishesTextIcons?.options}
                            value={dataMenus?.seconddishes}
                            onChange={(e) => handleSelectChange('seconddishes', e)}
                            // Usamos getOptionLabel solo para la búsqueda por texto
                            getOptionLabel={(option) => {
                                const labelChildren = option?.label?.props?.children;

                                // If labelChildren is an array, filter the strings
                                if (Array.isArray(labelChildren)) {
                                    const labelText = labelChildren.filter(child => typeof child === 'string');
                                    return labelText.join('');
                                }
                            
                                // If labelChildren is not an array (likely a string), return it directly
                                if (typeof labelChildren === 'string') {
                                    return labelChildren;
                                }
                            
                                // Fallback in case none of the above conditions are met
                                return option.label;
                            }}
                            // Usamos formatOptionLabel para renderizar la opción con imagen y texto
                            formatOptionLabel={(option) => {
                                const children = option?.label?.props?.children;
                            
                                // Verificamos si hay una imagen en la primera posición de los children
                                const image = children?.[0]?.props?.src 
                                    ? (
                                        <img
                                            src={children[0]?.props?.src}
                                            alt={children[0]?.props?.alt || 'Imagen del plato'}
                                            style={{ height: '30px', width: '30px', marginRight: '10px' }}
                                        />
                                    )
                                    : null;
                            
                                // Extraemos el texto de los children
                                const text = Array.isArray(children)
                                    ? children.filter(child => typeof child === 'string').join('') || children[2]
                                    : typeof children === 'string'
                                    ? children
                                    : '';
                            
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {image}
                                        <span>{text}</span>
                                    </div>
                                );
                            }}

                            required
                        />
                    </Row>
                    {/* <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.drinks')}</h2>
                        <Select
                            className="text-start p-0"
                            isMulti
                            name={'drinks'}
                            options={drinksTextIcons.options}
                            value={dataMenus?.drinks}
                            onChange={(e) => handleSelectChange('drinks', e)}
                            required
                        />
                    </Row>
                    */}
                    <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.desserts')}</h2>
                        <Select
                            className="text-start p-0"
                            isMulti
                            name={'desserts'}
                            options={dessertsTextIcons?.options}
                            value={dataMenus?.desserts}
                            onChange={(e) => handleSelectChange('desserts', e)}
                            // Usamos getOptionLabel solo para la búsqueda por texto
                            getOptionLabel={(option) => {
                                const labelChildren = option?.label?.props?.children;

                                // If labelChildren is an array, filter the strings
                                if (Array.isArray(labelChildren)) {
                                    const labelText = labelChildren.filter(child => typeof child === 'string');
                                    return labelText.join('');
                                }

                                // If labelChildren is not an array (likely a string), return it directly
                                if (typeof labelChildren === 'string') {
                                    return labelChildren;
                                }
                            
                                // Fallback in case none of the above conditions are met
                                return option.label;
                            }}
                            // Usamos formatOptionLabel para renderizar la opción con imagen y texto
                            formatOptionLabel={(option) => {
                                const children = option?.label?.props?.children;
                                const image = children?.[0]?.props?.src
                                    ? (
                                        <img
                                            src={children[0]?.props?.src}
                                            alt={children[0]?.props?.alt || 'Imagen del postre'}
                                            style={{ height: '30px', width: '30px', marginRight: '10px' }}
                                        />
                                    )
                                    : null;
                                const text = Array.isArray(children)
                                    ? children.filter(child => typeof child === 'string').join('') || children[2]
                                    : typeof children === 'string'
                                    ? children
                                    : '';
                                return (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        {image}
                                        <span>{text}</span>
                                    </div>
                                );
                            }}
                            required
                        />
                    </Row>
                    {/*
                    <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.menus.complements')}</h2>
                        <Select
                            className="text-start p-0"
                            isMulti
                            name={'complements'}
                            options={complementsTextIcons.options}
                            value={dataMenus?.complements}
                            onChange={(e) => handleSelectChange('complements', e)}
                            required
                        />
                    </Row> */}
                    <Row className="text-center my-3">
                        <Col>
                            <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                            {isEditing
                                ?
                                    <>
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </>
                                :
                                    <>{t('admin.menus.update')}</>
                            }
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Row>
        </Container>
	)
}